<template>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label>Product SKUs</label>
                <multi-select 
                    :options="skus" 
                    :selected-options="selected_options_skus" 
                    class="form-control"   
                    placeholder="ตรงนี้ใส่รหัสสินค้านะจ๊ะ เช่น P084"
                    @select="onSelectSku"
                    @searchchange="searchSkus"
                ></multi-select>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue-search-select/dist/VueSearchSelect.css'
import { ModelSelect } from 'vue-search-select'; 
import { MultiSelect  } from 'vue-search-select';
export default {
    props:{
        language:[],
        skus:[],
        selected:[],
        partIdx: ""
    },
    name:'SelectSkus',
    components: {
        ModelSelect,
        MultiSelect,        
    },    
    data(){
        return {            
            selected_options_skus:[]
        }
    },
    mounted() {
        //console.log('Component mounted.')            
        this.selected_options_skus = this.selected
        // console.log('selected', this.selected);
        // console.log("this.languages (selectSku)00000",this.language);
        // console.log("items (selectSku)",this.selected);
    },
    created(){
        // console.log(this.tags);            
        // this.selected_options = this.selected
        // console.log('selected', this.selected)
    },
    methods:{        
        onSelectSku (items, lastSelectItem) {   
            
            // console.log('selected SKUs', this.selected)           
            this.selected_options_skus = items                
            this.lastSelectSkus = lastSelectItem
            this.language.language_parts[this.partIdx].skus = this.selected_options_skus;
            // this.language.language_parts[this.partIdx].skus = this.selected_options.map(item => item.text).join(',') ;
            console.log("this.language (selectSku)",this.language);
            console.log("selected_option (selectSku)",this.selected_options_skus);
            // console.log("this.partIdx (selectSku)",this.partIdx);
            // console.log("this.language.skus",this.language.skus);
            // console.log("items (selectSku)",items);

        },            
        reset () {
            // this.tags = {}
        },
        selectFromParentComponent1 () {
            // select option from parent component
            // this.tags = this.options[0]
        },
        reset2 () {
            this.item2 = ''
        },
        selectFromParentComponent2 () {
            // select option from parent component
            // this.item2 = this.options2[0].value
        },
        searchSkus(searchTextSkus){
            setTimeout(() => {
                this.$emit('searchSkus', searchTextSkus);
            }, 400); // 0.4 second delay
            // this.$emit('searchSkus', searchTextSkus);
        }
    }
    
}
</script>